import React, { useState } from "react";
import { Link } from "react-router-dom";
import { menuItems } from "../../util/sidebarMenu";
import { RenderSecure } from "../../util/script/RenderSecure";

const Sidebar = () => {
  const [activeMenu, setActiveMenu] = useState(null); // Track the currently open menu

  // Function to handle submenu toggling
  const toggleMenu = (menuTitle) => {
    setActiveMenu((prevMenu) => (prevMenu === menuTitle ? null : menuTitle)); // Close previous & open new
  };

  return (
    <div className="sidebar-main sidebar-menu-one sidebar-expand-md sidebar-color">
      {/* Mobile Sidebar Header */}
      <div className="mobile-sidebar-header d-md-none">
        <div className="header-logo">
          <Link to="/"><img src="/assets/img/buzz.png" alt="logo" style={{height: '40px'}}/></Link>
        </div>
      </div>

      {/* Sidebar Menu */}
      <div className="sidebar-menu-content">
        <ul className="nav nav-sidebar-menu sidebar-toggle-view">
          {menuItems.map((menu, index) => {
            const isOpen = activeMenu === menu.title;

            return (
              <RenderSecure key={index} code={menu.secureCode}>
              <li className={`nav-item ${menu.subMenu ? "sidebar-nav-item" : ""} ${isOpen ? "active" : ""}`}>
                {/* Main Menu Item */}
                <Link 
                  to={menu.subMenu ? "#" : menu.path} 
                  className="nav-link"
                  onClick={menu.subMenu ? () => toggleMenu(menu.title) : undefined}
                >
                  <i className={menu.icon}></i>
                  <span>{menu.title}</span>
                </Link>

                {/* Sub-menu */}
                {menu.subMenu && (
                  <ul className={`nav sub-group-menu ${isOpen ? "menu-open" : ""}`} style={{ display: isOpen ? "block" : "none" }}>
                    {menu.subMenu.map((subMenuItem, subIndex) => (
                      <li key={subIndex} className="nav-item">
                        <Link to={subMenuItem.path} className="nav-link">
                          <i className="fas fa-angle-right"></i> {subMenuItem.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
              </RenderSecure>

            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
